import { Button } from "@mantine/core";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useToast } from "../../../../mantine/notifications/useToast";
import { MANAGER_URL } from "../../../../routes";
import type { Project } from "../../../../utils/backend-types";
import {
  ActionConfirmationModal,
  ActionObject
} from "../../../BuildingBlocks/Layout/Modals/ActionConfirmationModal/ActionConfirmationModal";

interface DeleteProjectWidgetProps {
  project?: Project;
  showStaffView?: boolean;
}

function DeleteProjectWidget({
  project,
  showStaffView
}: DeleteProjectWidgetProps) {
  const { showErrorToast } = useToast();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  function handleClickDeleteProject() {
    setIsModalOpen(true);
  }

  function handleCloseActionModal() {
    setIsModalOpen(false);
  }

  function handleActionSuccess() {
    navigate(`${MANAGER_URL}/dashboard/`);
  }

  function handleError(error: unknown) {
    showErrorToast(error);
  }

  if (!showStaffView) {
    return null;
  }

  return (
    <>
      <Button
        color="error"
        disabled={!project}
        onClick={handleClickDeleteProject}
      >
        Projekt löschen
      </Button>
      {isModalOpen && project && (
        <ActionConfirmationModal
          object={ActionObject.Project}
          project={project}
          onActionSuccess={handleActionSuccess}
          onClose={handleCloseActionModal}
          onError={handleError}
        />
      )}
    </>
  );
}

export { DeleteProjectWidget, DeleteProjectWidgetProps };
